<template>
  <div v-if="infoUser" class="card is-paddingless">
    <header class="header-card">
      <p>
        {{ $t('firstStepUtilisateur.infosUtilisateur.title')}}
      </p>
    </header>
    <div class="card-content is-marginless">
      <div class="columns is-multiline">
        <div class="column is-3 is-paddingless">
          <figure class="media-left">
            <app-logo ></app-logo>
          </figure>
        </div>
        <div class="column is-9 columns is-multiline">
          <div class="column is-6">
            <parametre-autocomplete
              :label="$t('firstStepUtilisateur.infosUtilisateur.civilite')"
              v-model="infoUser.civiliteId"
              :target="constantes.typesParametres.PARAMETRES_KEYS.civilite"
              expanded
            />
          </div>
          <div class="column is-6">
            <b-field :label="$t('firstStepUtilisateur.infosUtilisateur.agence')"
                      class="obligatoire">
              <b-select v-model="infoUser.agenceId" expanded @input="editAgenceRattachement()">
                <option v-for="agence in listeAgences"
                        :key="agence.id"
                        :value="agence.id">
                  {{ agence.title }}
                </option>
              </b-select>
            </b-field>
          </div>
          <div class="column is-6">
            <b-field :label="$t('firstStepUtilisateur.infosUtilisateur.nom')"
                      class="obligatoire">
              <b-input v-model="infoUser.nom"></b-input>
            </b-field>
          </div>
          <div class="column is-6">
            <b-field :label="$t('firstStepUtilisateur.infosUtilisateur.prenom')">
              <b-input v-model="infoUser.prenom"></b-input>
            </b-field>
          </div>
          <div class="column is-6">
            <app-input-email :label="$t('firstStepUtilisateur.infosUtilisateur.email')"
                              v-model="infoUser.email"/>
          </div>
          <div class="column is-6">
            <b-field :label="$t('firstStepUtilisateur.infosUtilisateur.tel')">
              <b-input v-model="infoUser.telephone"></b-input>
            </b-field>
          </div>
          <div class="column is-6">
            <b-field :label="$t('firstStepUtilisateur.infosUtilisateur.profil')"
                      class="obligatoire">
              <b-select v-model="infoUser.profil" expanded :disabled="infoUser.regieExterne">
                <option v-for="profil in listeProfil"
                        :key="profil.code"
                        :value="profil.code">
                  {{ $t(profil.libelle) }}
                </option>
              </b-select>
            </b-field>
          </div>
          <div class="column is-12 columns">
            <div class="column is-3"  v-if="OtTechniqueActive">
              <b-tooltip
                :label="$t('firstStepUtilisateur.infosUtilisateur.estTechnicienToolTip')">
                <b-field>
                  <b-checkbox v-model="infoUser.estTechnicien" >
                    {{ $t('firstStepUtilisateur.infosUtilisateur.estTechnicien') }}
                  </b-checkbox>
                </b-field>
              </b-tooltip>
            </div>
            <div class="column is-3" >
              <b-tooltip
                :label="$t('firstStepUtilisateur.infosUtilisateur.estAfficheurToolTip')">
                <b-field>
                  <b-checkbox v-model="infoUser.estAfficheur" >
                    {{ $t('firstStepUtilisateur.infosUtilisateur.estAfficheur') }}
                  </b-checkbox>
                </b-field>
              </b-tooltip>
            </div>
            <div class="column is-3">
              <b-checkbox v-model="infoUser.regieExterne" @input="editProfil($event)">
                {{ $t('firstStepUtilisateur.infosUtilisateur.regieExterne') }}
              </b-checkbox>
            </div>
            <div class="column is-4">
              <b-checkbox v-model="infoUser.responsableBail" >
                {{ $t('firstStepUtilisateur.infosUtilisateur.responsableBail') }}
              </b-checkbox>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import { createNamespacedHelpers } from 'vuex';
import Logo from '@/components/general/Logo';
import * as typesParametres from '@/store/modules/parametres-mutation-type';
import messageErreur from '@/services/general/messageErreur';
import * as utilisateurConf from '@/configuration/parametrage/utilisateurConf';
import { getAgencesRattachement } from '@/services/societe/getAgenceRattachement';
import InputEmail from '@/components/general/inputEmail';
import parametreAutocomplete from '@/components/general/autocomplete/parametreAutocomplete';

const Parametres = createNamespacedHelpers('parametres');

export default {
  props: {
    infoUser: Object,
  },
  components: {
    appLogo: Logo,
    appInputEmail: InputEmail,
    parametreAutocomplete,
  },
  data() {
    return {
      listeProfil: utilisateurConf.LISTE_PROFIL,
      listeAgences: [],
      constantes: {
        typesParametres,
      },
    };
  },
  methods: {
    ...Parametres.mapActions({
      loadParametresInterne: 'loadParametresInterne',
    }),
    editAgenceRattachement() {
      this.$emit('editAgenceRattachement');
    },
    editProfil(event) {
      if (event) {
        this.infoUser.profil = utilisateurConf.COMMERCIAL;
      }
    },
  },
  computed: {
    ...Parametres.mapGetters({
      parametresInterne: 'parametresInterne',
    }),
    OtTechniqueActive() {
      return this.parametresInterne(
        typesParametres.PARAMETRES_INTERNE_KEYS.afficherLogistiqueTechnique.key);
    },
  },
  async mounted() {
    const loadingComponent = this.$buefy.loading.open();
    try {
      await this.loadParametresInterne([
        typesParametres.PARAMETRES_INTERNE_KEYS.afficherLogistiqueTechnique.key]);
      this.listeAgences = await getAgencesRattachement();
      loadingComponent.close();
    } catch (e) {
      messageErreur(this.$i18n);
      loadingComponent.close();
      throw e;
    }
  },
};
</script>

<style scoped>

</style>
